import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { manageFootballCompetitionService } from "../../../../../commons";
import { EnsueCollection } from "../../../../../ensue-react-system/utilities/ensue-collection";
import { StatusEnum } from "../../../../../commons/enums/status-enum";
import { ManageFootballCompetitionInvitedTeam } from "../../../../../commons/models/football/admin/manage-football-competition-invited-team";

export interface IManageCompetitionSeasonTeamsState {
  competitionSeasonInvitedTeams: EnsueCollection<ManageFootballCompetitionInvitedTeam>;
  competitionSeasonInvitedTeamsStatus: StatusEnum;
}

export interface IManageCompetitionTeamsOption {
  competitionId: number;
  seasonId: number;
  urlParams?: {
    hostTeamId?: number;
  };
}

const initialState: IManageCompetitionSeasonTeamsState = {
  competitionSeasonInvitedTeams: new EnsueCollection<ManageFootballCompetitionInvitedTeam>(),
  competitionSeasonInvitedTeamsStatus: StatusEnum.Idle,
};

export const fetchCompetitionSeasonInvitedTeams = createAsyncThunk(
  "manage/competitionSeasonInvitedTeams",
  async (options: IManageCompetitionTeamsOption, thunkAPI) => {
    try {
      const competitionInvitedTeams = await manageFootballCompetitionService.getInvitedTeamList(
        options.competitionId,
        options.seasonId,
        options.urlParams
      );
      return competitionInvitedTeams;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageCompetitionSeasonInvitedTeamsSlice = createSlice({
  name: "competitionSeasonInvitedTeams",
  initialState: initialState,
  reducers: {
    cleanUpCompetitionSeasonInvitedTeams(state) {
      state.competitionSeasonInvitedTeams = new EnsueCollection<ManageFootballCompetitionInvitedTeam>();
      state.competitionSeasonInvitedTeamsStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchCompetitionSeasonInvitedTeams.pending, (state) => {
        state.competitionSeasonInvitedTeamsStatus = StatusEnum.Loading;
      })
      .addCase(
        fetchCompetitionSeasonInvitedTeams.fulfilled,
        (state, action: PayloadAction<EnsueCollection<ManageFootballCompetitionInvitedTeam>>) => {
          state.competitionSeasonInvitedTeamsStatus = StatusEnum.Succeeded;
          state.competitionSeasonInvitedTeams = action.payload;
        }
      )
      .addCase(fetchCompetitionSeasonInvitedTeams.rejected, (state) => {
        state.competitionSeasonInvitedTeamsStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpCompetitionSeasonInvitedTeams } = manageCompetitionSeasonInvitedTeamsSlice.actions;
export default manageCompetitionSeasonInvitedTeamsSlice.reducer;
